import Widget from "@components/partnerLPs/bike";
import proposalDataModule from "@store/moData/proposalData";
import analyticsModule from "@analytics/bike/index";
import errorDataModule from "@store/errorData";
import withDynamicModules from "@store/dynamic/withDynamicModules";
import PartnersConfig from "@components/partnerLPs/common/partnerConfig";
import { NextPageContext } from "next";
import JSEncrypt from "nodejs-jsencrypt";
import getParameterByName from "@utils/getQueryParams";
import regexDataModule from "@store/regex";

const Index = resData => {
  return <Widget data={resData} />;
};

Index.getInitialProps = async (ctx: NextPageContext) => {
  let resData = {};
  if (ctx.res) {
    const eData = getParameterByName("mgik", ctx?.req?.url);
    if (eData) {
      try {
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(process.env.MYGATE_DKEY);
        const parsedData = JSON.parse(decrypt.decrypt(eData) || "{}");
        resData = {
          m: parsedData?.mobile_number || "",
          p: parsedData?.pincode || "",
          v: parsedData?.vehicles[0]?.vhnum || ""
        };
      } catch {
        resData = {};
      }
    }
    const path = ctx.asPath;
    let isPartnerValid = false;
    Object.keys(PartnersConfig).forEach(p => {
      if (path?.includes(p) && PartnersConfig[p]?.bike) {
        isPartnerValid = true;
      }
    });
    if (!isPartnerValid) {
      const { res } = ctx;
      // Location to be replaced with actual 404 page
      res.writeHead(302, { Location: `https://acko.com/404` });
      res.end();
    }
    return { resData };
    // Check if invalid LP url then redirect to 404 else return isMobile prop
  }
};
export default withDynamicModules(Index, [
  proposalDataModule(),
  analyticsModule(),
  errorDataModule(),
  regexDataModule()
]);
